import { z } from 'zod';
import { AuditSourceSchema } from '../enums.js';
import { IdSchema, IsoDateTimeSchema } from './common.js';
/** The fixed vocabulary of audited actions. Keep additions here in sync with every call site
 * that writes through withAudit() in apps/api. */
export const AUDIT_ACTIONS = [
    'org.created',
    'org.updated',
    'org.deleted',
    'org.member_added',
    'org.member_removed',
    'org.member_role_changed',
    'org.dev_preferences_updated',
    'org.training_defaults_updated',
    'org.invite_created',
    'org.invite_revoked',
    'org.invite_accepted',
    'project.created',
    'project.updated',
    'project.member_added',
    'project.member_removed',
    'project.member_role_changed',
    'project.deleted',
    'document.version_created',
    'document.validated_llm_output',
    'questionnaire.completed',
    'tasks.generated',
    'tasks.validated',
    'task.field_changed',
    'task.deleted',
    'task.status_changed',
    'task.assignment_changed',
    'task.comment_added',
    'task.issue_raised',
    'task.issue_resolved',
    'deliverable.added',
    'deliverable.deleted',
    'regeneration.created',
    'regeneration.proposal_decided',
    'export.generated',
    'training.source_added',
    'training.source_removed',
    'training.settings_updated',
    'training.sessions_saved',
    'training.sessions_confirmed',
    'training.outline_saved',
    'training.outline_confirmed',
    'training.deck_version_created',
    'training.deck_version_restored',
    'training.stale_dismissed',
    'training.prep_tasks_created',
    'allowlist.domain_added',
    'allowlist.domain_removed',
    'mcp.access_granted',
    'mcp.access_revoked',
    'user.platform_admin_changed',
    'user.first_sign_in',
    'user.sign_in_denied',
];
export const AuditActionSchema = z.enum(AUDIT_ACTIONS);
/** auditLogs/{id} — written in the same transaction as the domain change it describes. A
 * project-scoped entry is also mirrored, minus `ip`, to projects/{projectId}/activity/{id} — the
 * feed project members read (see services/audit.ts). The full log here is org admins' and project
 * leads' only. */
export const AuditLogEntrySchema = z.object({
    id: IdSchema,
    ts: IsoDateTimeSchema,
    actorUid: IdSchema,
    orgId: IdSchema.nullable().default(null),
    projectId: IdSchema.nullable().default(null),
    action: AuditActionSchema,
    targetRef: z.string(), // e.g. "projects/p1/tasks/t4"
    summary: z.string().max(500).optional(),
    before: z.record(z.string(), z.unknown()).optional(),
    after: z.record(z.string(), z.unknown()).optional(),
    ip: z.string().optional(),
    source: AuditSourceSchema,
});
//# sourceMappingURL=auditLog.js.map